export default "__VITE_ASSET__MZfhasT4__"